<template>

<div>

    <app-header />


  <div class="container">

		<nav aria-label="breadcrumb">
			<ol class="breadcrumb">
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id">{{ project.name }}</router-link></li>
				<li class="breadcrumb-item"><router-link :to="'/project/'+project.id+'/tables'">{{ _lang('Collections') }}</router-link></li>
				<li class="breadcrumb-item"><router-link :to="`/project/${project.id}/table/${table.id}/browse`">{{table.name}}</router-link></li>
				<li v-if="id" class="breadcrumb-item active" aria-current="page">{{ _lang('Edit') }}</li>
				<li v-else class="breadcrumb-item active" aria-current="page">{{ _lang('New') }}</li>
			</ol>
		</nav>

      <form @submit.prevent="onSubmit">

        <div class="form-group" v-if="table.meta.includeTitle">
          <label>{{ _lang('Title') }}</label>
          <input v-model="post.name" type="text" class="form-control" required @blur="firstSlug">
        </div>
        <div class="form-group" v-if="table.meta.hasSingular">
          <label>{{ _lang('Slug') }}</label>
          <input v-model="post.slug" type="text" class="form-control" required>
        </div>


        <div v-for="field in table.fields" class="form-group">
          <label>{{field.name}}</label>
          <div v-if="field.type=='text'">
            <input v-model="post.fields[field.id]" type="text" class="form-control" :required="field.required=='1'">
          </div>
          <div v-if="field.type=='string'">
            <input v-model="post.fields[field.id]" type="text" class="form-control" :required="field.required=='1'">
          </div>
					<div v-if="field.type=='whatsapp_link'">
            <custom-input v-model="post.fields[field.id]" :type="field.type" :required="field.required=='1'" />
          </div>
					<div v-if="field.type=='telephone_link'">
            <custom-input v-model="post.fields[field.id]" :type="field.type" :required="field.required=='1'" />
          </div>
					<div v-if="field.type=='email_link'">
            <custom-input v-model="post.fields[field.id]" :type="field.type" :required="field.required=='1'" />
          </div>

          <div v-if="field.type=='textarea'">
            <textarea v-model="post.fields[field.id]" class="form-control" :required="field.required=='1'"></textarea>
          </div>
          <div v-if="field.type=='csvtable'">
            <textarea v-model="post.fields[field.id]" class="form-control" :required="field.required=='1'"></textarea>
          </div>

          <div v-if="field.type=='wysiwyg'">
            <textarea v-model="post.fields[field.id]" class="form-control form-editor" :data-field-id="field.id" :required="field.required=='1'"></textarea>
          </div>

          <div v-if="field.type=='currency'">
            <currency-input v-model="post.fields[field.id]" :symbol="field.meta.symbol" :format="field.meta.format" />
          </div>
          <div v-if="field.type=='image'">
            <img v-if="post.fields[field.id]" :src="post.fields[field.id]" class="thumb">
            <input type="file" @change="onFileChange($event,field.id)" class="form-control">
          </div>
          <div v-if="field.type=='file'">
            <span>{{ post.fields[field.id]?post.fields[field.id].split('/').pop():'' }}</span>
            <input type="file" @change="onFileChange($event,field.id)" class="form-control">
          </div>

          <div v-if="field.type=='gallery'">
            <div v-if="post.fields[field.id]" :ref="'gallery'+field.id" :data-field-id="field.id" class="gallery">
              <figure draggable v-for="(row,index) in post.fields[field.id]" :track-by="row.src" :key="row.src">
                <div class="handle"></div>
                <img :src="row.src" :key="row.src" class="thumb">
                <input type="text" v-model="row.caption" class="form-control">
                <span @click="remove(post.fields[field.id],row)">&times;</span>
              </figure>
            </div>
            <input type="file" multiple @change="onFileChangeGallery($event,field.id)" class="form-control">
          </div>

          <div v-if="field.type=='multiple-file'">
            <div v-if="post.fields[field.id]" :ref="'multiple-file'+field.id" :data-field-id="field.id" class="multiple-file">
              <div draggable v-for="(row,index) in post.fields[field.id]" :track-by="row.src" :key="row.src">
                <div class="handle"></div>
                <input type="text" :value="row.src?row.src.split('/').pop():''" readonly class="form-control">
                <input type="text" v-model="row.caption" class="form-control">
                <span @click="remove(post.fields[field.id],row)">&times;</span>
              </div>
            </div>
            <input type="file" multiple @change="onFileChangeGallery($event,field.id)" class="form-control">
          </div>

          <div v-if="field.type=='select'">
            <select v-model="post.fields[field.id]" class="form-control" :required="field.required=='1'">
              <option v-for="option in field.options" :value="option.name">{{option.name}}</option>
            </select>

          </div>

          <div v-if="field.type=='multiselect'" class="multiselect">
            <label v-for="option in field.options">
              <input v-model="post.fields[field.id]" type="checkbox" :value="option.name">
							{{option.name}}
						</label>
          </div>

          <div v-if="field.type=='checkbox'">
            <label>
              <input v-model="post.fields[field.id]" :true-value="1" :false-value="0" type="checkbox">
							{{field.name}}
						</label>
          </div>

          <div v-if="field.type=='image-select'">
            <select v-model="post.fields[field.id]" class="form-control" :required="field.required=='1'">
              <option v-for="option in field.options" :value="option.image">{{option.name}}</option>
            </select>
            <img v-if="post.fields[field.id]" :src="post.fields[field.id]" style="max-width:50px; max-height:50px;">
          </div>
          <div v-if="field.type=='relation' && tablePosts[field.meta.table]">
            <select v-model="post.fields[field.id]" class="form-control" :required="field.required=='1'">
              <option v-for="related_post in tablePosts[field.meta.table]" :value="related_post.id">{{related_post.name || related_post.id + ' - ' + related_post.slug }}</option>
            </select>

          </div>


        </div>

        <div class="">
          <button type="submit" class="btn btn-primary">{{ _lang('Save') }}</button>
          <span class="btn btn-light" @click="goBack">{{ _lang('Back') }}</span>
          <span v-if="id" class="btn btn-danger" @click="trash">{{ _lang('Delete') }}</span>
        </div>


      </form>

    </div>
</div>

</template>
<script>

import axios from 'axios';
import appHeader from '../components/appHeader.vue'
import currencyInput from '../components/currencyInput.vue'
import customInput from '../components/customInput.vue'

export default {
	props:['project_id','table_id','id'],
  components:{
		appHeader,
		currencyInput,
		customInput,
	},
  data() {
    return {
			table:{meta:{}},
      post:{
				name:'',
				slug:'',
        fields:{}
      },
      tablePosts:{},
    }
	},
	computed:{
		project(){
			return this.$store.state.project;
		},
	},
	watch:{
		'post.slug':function(newValue){
			this.post.slug = this.createSlug(newValue)
		}
	},
  methods:{
		firstSlug(){
			if(this.post.slug==''){
				this.post.slug = this.createSlug(this.post.name)
			}
		},
		createSlug(text){
			return text.trim().normalize('NFD').replace(/\p{Diacritic}/gu, "").toLowerCase().replace(/[^a-z0-9_-]/g,'-').replace(/-+/g,'-')
		},
  	remove(arr,el){
  		var i = arr.indexOf(el);
  		arr.splice(i,1);
  	},
		onFileChangeGallery(event,field_id){
			var files = event.target.files || event.dataTransfer.files;

			// event.target.value='';

			for(const file of files){

				var reader = new FileReader();
				reader.onload = (e) => {
					var base64 =  e.target.result;
					var data = {
	          prefix:[this.$store.state.user.id,this.project_id,this.table_id],
						name:file.name,
						content:base64
					}

					axios.post('/api/upload',data,{
						onUploadProgress: (progressEvent) => {
							const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
							if (totalLength !== null) {
								//console.log('progress',Math.round( (progressEvent.loaded * 100) / totalLength ));
								}
							}
						})
					.then((response)=> {
						//console.log('upload complete')
						//console.log('set new value:',response.data)
						console.log('upload done',this.post.fields[field_id]);
						console.log('respones',response.data);
						if(!Array.isArray(this.post.fields[field_id])) this.$set(this.post.fields,field_id,[]);
	          this.post.fields[field_id].push({src:response.data,caption:file.name.replace(/\.[^.]+$/i,'')});
					})
					.catch((error) =>  {
						console.error(error);
						if(error.response) alert(error.response.data);
					})
				};
				reader.readAsDataURL(file);
			}

		},

    onFileChange(event,field_id){

			var files = event.target.files || event.dataTransfer.files;

			var file = files[0];
			if(!file) return;
			event.target.value='';


			var reader = new FileReader();
			reader.onload = (e) => {
				var base64 =  e.target.result;
				var data = {
          prefix:[this.$store.state.user.id,this.project_id,this.table_id],
					name:file.name,
					content:base64
				}

				axios.post('/api/upload',data,{
					onUploadProgress: (progressEvent) => {
						const totalLength = progressEvent.lengthComputable ? progressEvent.total : progressEvent.target.getResponseHeader('content-length') || progressEvent.target.getResponseHeader('x-decompressed-content-length');
						if (totalLength !== null) {
							//console.log('progress',Math.round( (progressEvent.loaded * 100) / totalLength ));
							}
						}
					})
				.then((response)=> {
					//console.log('upload complete')
					//console.log('set new value:',response.data)
          this.post.fields[field_id] = response.data;
					this.$forceUpdate();
				})
				.catch((error) =>  {
					console.error(error);
					if(error.response) alert(error.response.data);
				})
			};
			reader.readAsDataURL(file);
    },
    goBack(){
      this.$router.go(-1);
      this.$router.push({ name: 'project-table-data', params: { project_id:this.project_id, table_id:this.table_id} })
    },
    onSubmit(){


    	//get data from editor
    	if(tinymce && tinymce.editors.length>0){
				tinymce.editors.forEach(editor=>{
						var field_id = editor.targetElm.getAttribute('data-field-id');
						var content =  editor.getContent();
						this.post.fields[field_id] = content;
				})
    	}
      let data = {
          table_id:this.table_id,
          ...this.post,
      }
      axios({
        method: 'post',
        url: '/api/posts'+(data.id?`/${data.id}`:''),
        data: data
      }).then((res) => {
        this.$router.push({ name: 'project-table-data', params: { project_id:this.project_id, table_id:this.table_id} })
      });
    },
    trash(){
      if(!confirm(this._lang('Are you sure?'))) return;
      axios({
        method: 'delete',
        url: '/api/posts/'+this.post.id,
      }).then((res) => {
        this.$router.push({ name: 'project-table-data', params: { project_id:this.project_id, table_id:this.table_id} })
      });
    },

    getData(){
			let table_id = this.table_id;
			var queue = []
			var q = axios({
				url: '/api/tables/'+table_id,
			}).then((res) => {
				if(!res.data.meta) res.data.meta = {};
				this.table = res.data;
				this.table.fields.forEach(field=>{
					if(field.type=='relation'){
						this.getTablePosts(field.meta.table);
					}
				})
			});
			queue.push(q);

			if(this.id){
				var q = axios({
					url: '/api/posts/'+this.id,
				}).then((res) => {
					let post = res.data;
					let fields = {};
					res.data.fields.forEach(item => {
						fields[item.field_id] = item.value;
					})
					post.fields = fields;
					this.post = post;
				});
				queue.push(q);
			}
			Promise.all(queue).then(()=>{
				this.wysiwyg();

				this.table.fields.forEach(field=>{
					//initialize empty arrays
					if(field.type=='multiselect' && !Array.isArray(this.post.fields[field.id])) this.post.fields[field.id] = [];
				})

			})
    },
		getTablePosts(table_id){
			if(this.tablePosts[table_id]) return;
			axios({
				url: '/api/data/'+table_id,
			}).then((res) => {
				this.$set(this.tablePosts,table_id,res.data.posts)
			});
		},

		handleDrag([parentNode,oldIndex,newIndex]){
			var field_id = parentNode.getAttribute('data-field-id');
			var arr = this.post.fields[field_id];

			if(newIndex >= arr.length){
				var removed = arr.splice(oldIndex,1);
				var dragElm = removed[0];
				arr.push(dragElm);
			} else {
				if(oldIndex<=newIndex) newIndex--;
				var removed = arr.splice(oldIndex,1);
				var dragElm = removed[0];
				arr.splice(newIndex,0,dragElm);
			}

		},
		wysiwyg(){
			var texteditors = document.querySelectorAll('.form-editor').length;
			console.log('texteditors',texteditors);

			this.$nextTick(function () {

				tinymce.init({selector:'.form-editor', height : 300,
					plugins: [
					" autolink link lists hr pagebreak image imagetools ",
					"code template textcolor textpattern print",
					],

					toolbar1: "bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | link unlink | file fileupload | styleselect | image imagetools",
					toolbar2: "bullist numlist | outdent indent blockquote | undo redo | hr removeformat template pagebreak | code | print",
					relative_urls:false,
					browser_spellcheck: true,

					images_upload_handler: (blobInfo, success, failure) => {
						var filename = blobInfo.filename();
						var ext_r = filename.match(/(png|jpe?g)$/i)
						if(!ext_r) {
							failure('Erro: envie somente imagens em JPG ou PNG.');
							return;
						}
						var ext = ext_r.pop().toLowerCase().replace('jpg','jpeg');
						var base64 = `data:image/${ext};base64,` + blobInfo.base64();

						var data = {
								prefix:['admin',this.project.id,this.table.id],
								name:filename,
								content:base64
						}

						//admin to cms
						axios.post('/api/upload',data)
						.then((response)=> {
								success(response.data)
						})
						.catch((error) =>  {
								console.error(error);
								failure(error.response.data)
						})
					},

					menubar: false,
					toolbar_items_size: 'small',
					entity_encoding : 'raw',

					content_style: "body { font-family: Calibri, Arial, sans-serif !important; font-size:15px !important; text-align:justify; }",

					templates: [{ title: 'Tabela', content: '<table><tr><td>primeiro</td><td>segundo</td></tr></table>' }],
					style_formats: [{ title: 'Vermelho claro', inline: 'span', styles: { color: '#990000' } }, { title: 'Vermelho escuro', block: 'span', styles: { color: '#632423' } }],
				});
				console.log('tinymce.editors.length',tinymce.editors.length);
			})
		}

  },
  mounted(){
		window.draggable.subscribe(this.handleDrag)
		this.getData().then((res)=>{


		});

  },
  beforeDestroy(){
  	window.draggable.unsubscribe(this.handleDrag)
  }
}



</script>

<style scoped>

.multiselect label { display:block; margin:0;}
.thumb {
	width:80px;
	height:45px;
	object-fit: contain;
}
.gallery{ }
.gallery figure{ display:flex; align-items: center;}
.gallery figure img{ flex-shrink: 0;}
.gallery figure input{}
.gallery figure span{ font-weight:bold; padding:5px; cursor:pointer; color:#c00; }

.multiple-file{ }
.multiple-file > div { display:flex; align-items: center; padding-left:10px;}
.multiple-file span{ font-weight:bold; padding:5px; cursor:pointer; color:#c00; }


</style>
